import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import _ from 'lodash'; // import cx from 'classnames'

import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import DataTable from '../ui/table';
import Card from '../ui/card';
import DropDown from '../ui/react-ui/dropdown';
import TrafficLiveTrafficChart from './traffic-liveTraffic-chart'; // Api

import { getVds } from '../../api/deviceAPI'; // Redux

import { setVdsData, setVdsSort, setVdsTotalCount } from '../../redux/traffic-prediction';
var t = i18n.getFixedT(null, 'traffic-prediction');
var gt = i18n.getFixedT(null, 'app');
var LiveTraffic = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$trafficP = _useSelector.trafficPrediction,
      vdsSort = _useSelector$trafficP.vdsSort,
      vdsData = _useSelector$trafficP.vdsData,
      vdsTotalCount = _useSelector$trafficP.vdsTotalCount,
      trafficLiveChartData = _useSelector$trafficP.trafficLiveChartData;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(10),
      _useState6 = _slicedToArray(_useState5, 2),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      dataSource = _useState8[0],
      setDataSource = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      loading = _useState10[0],
      setLodaing = _useState10[1];

  var id = props.id;
  var isMounted = useRef(false);
  var dataSourceList = [// { value: 'TIPC', text: t('lbl-TIPC') },
  {
    value: 'Freeway',
    text: t('lbl-Freeway')
  }, {
    value: 'TBKC',
    text: t('lbl-TBKC')
  }, {
    value: 'KCHT',
    text: t('lbl-KCHT')
  }];

  var handleSort = function handleSort(sort) {
    dispatch(setVdsSort(sort));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleDataSourceChange = function handleDataSourceChange(val) {
    setDataSource(val);
  };

  var handleSortData = function handleSortData(d, sort) {
    var field = sort.field,
        desc = sort.desc;

    var newData = _.orderBy(d, [field], [desc ? 'desc' : 'asc']);

    return _.map(newData, function (el, index) {
      return _objectSpread(_objectSpread({}, el), {}, {
        sequence: index + 1
      });
    });
  };

  var handleData = function handleData() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    var newData = handleSortData(vdsData, vdsSort);
    newData = _.slice(newData, offset, offset + rowsPerPage);
    setTableData(newData);
  };

  var fetchVds = function fetchVds() {
    setLodaing(true);
    setCurrentPage(0);
    getVds(contextRoot, false, null, 0, null, dataSource).then(function (result) {
      var newData = _.map(result.content, function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          congestionStatus: parseInt(el.speed) === -1 ? -1 : el.congestionStatus
        });
      });

      setLodaing(false);
      dispatch(setVdsData(newData));
      dispatch(setVdsTotalCount(result.totalElements));
    }).catch(function (error) {
      setLodaing(false);
    });
  };

  useEffect(function () {
    fetchVds();
  }, [dataSource]);
  useEffect(function () {
    if (isMounted.current === false || loading === true) return;
    handleData();
  }, [JSON.stringify(vdsSort), currentPage, rowsPerPage]);
  useEffect(function () {
    handleData();
  }, [JSON.stringify(vdsData)]);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    }
  }, []);
  var statusLevels = ['low', 'middle', 'high'];
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'location', {
    label: t('lbl-area'),
    sortable: true
  });

  _.set(fields, 'speed', {
    label: t('lbl-speed'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "speed-div"
      }, val === -1 ? t('lbl-no-data') : _.round(val, 2) + '公里');
    }
  });

  _.set(fields, 'congestionStatus', {
    label: t('lbl-status'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (parseInt(row.speed) === -1) return t('lbl-no-data');
      return /*#__PURE__*/React.createElement("span", {
        className: statusLevels[row.congestionStatus - 1]
      }, row.congestionStatusName);
    }
  });

  _.set(fields, 'updatedAt', {
    label: t('lbl-update-time'),
    sortable: true
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "mb9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "live-traffic c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: vdsSort,
    onSort: handleSort
  }), /*#__PURE__*/React.createElement("div", {
    className: "live-traffic-table-bottom"
  }, /*#__PURE__*/React.createElement(DropDown, {
    className: "dataSource-selector",
    defaultText: t('lbl-select'),
    list: dataSourceList,
    value: dataSource,
    onChange: handleDataSourceChange
  }), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: vdsTotalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }))), /*#__PURE__*/React.createElement(Card, {
    title: t('lbl-prediction-road-status'),
    enableFullScreen: true
  }, /*#__PURE__*/React.createElement(TrafficLiveTrafficChart, {
    chartData: trafficLiveChartData
  })));
});
LiveTraffic.defaultProps = {
  id: 'g-live-traffic'
};
LiveTraffic.propTypes = {
  id: PropTypes.string
};
export default LiveTraffic;